module.exports = __webpack_public_path__ + "img/culture-3.da3436ee.jpg";